import {ValueObject} from '@s-ui/domain'

export default class UserTakeoutListValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {string} data.status
   * @param {Object} data.messages
   * @param {string} data.requestId
   * @param {string} data.requestedAt
   * @param {string} data.updatedAt
   * @param {Array<string>} data.filenames
   * */
}
